/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React, { ReactElement } from "react";
import styled from "styled-components";
import DOMPurify from "dompurify";

import ExpandedRow from "./expandedRow";
import { ApprovalRequest } from "../../interfaces/interfaces";

interface PendingAwardsFilterableTableRowProps {
  awardClaim: ApprovalRequest;
  handleApprovalRequest: (claim: ApprovalRequest, url: string) => void;
  handleToggleClaim: (claim: ApprovalRequest) => void;
  isLoading: boolean;
  selected: boolean;
  selectedFilter: string;
  levelsValid: boolean;
  incentiveAttachmentEnabled: boolean;
}

interface PendingAwardsFilterableTableRowState {
  expanded: boolean;
}

const StyledExpander = styled.div`
  &:hover {
    cursor: pointer;
  }

  .fa-angle-down,
  .fa-angle-right {
    width: 13px;
  }
`;
export default class PendingAwardsFilterableTableRow extends React.Component<
  PendingAwardsFilterableTableRowProps,
  PendingAwardsFilterableTableRowState
> {
  static defaultProps = {
    isLoading: false,
    selected: false,
  };

  state = {
    expanded: false,
  };

  toggleExpander = (): void => {
    this.setState((prevState) => {
      return { expanded: !prevState.expanded };
    });
  };

  render(): ReactElement {
    return (
      <>
        <tr className={`${this.getClaimClasses(this.props.awardClaim)}`}>
          {this.renderCaretIcon()}
          {this.renderCheckbox()}
          <td>
            <div>{this.props.awardClaim.claim.createdAt}</div>
          </td>
          <td>
            <div>{this.props.awardClaim.claim.name}</div>
          </td>
          <td>
            <div>{this.props.awardClaim.claim.bonusReason}</div>
          </td>
          <td>
            <div>
              {this.handleFormatUsers(
                this.props.awardClaim?.claim?.recipients || []
              )}
            </div>
          </td>
          {this.renderApproveOrDeny()}
          <td>
            <span
              className={
                this.props.awardClaim.errorMessage ? "text-danger" : ""
              }
            >
              {this.props.awardClaim.errorMessage}
            </span>
          </td>
        </tr>
        <ExpandedRow
          awardClaim={this.props.awardClaim}
          isExpanded={this.state.expanded}
          incentiveAttachmentEnabled={this.props.incentiveAttachmentEnabled}
        />
      </>
    );
  }

  renderCaretIcon = (): ReactElement => {
    return (
      <td>
        <StyledExpander className="expander" onClick={this.toggleExpander}>
          <i
            className={
              this.state.expanded ? `fas fa-angle-down` : `fas fa-angle-right`
            }
          />
        </StyledExpander>
      </td>
    );
  };

  renderCheckbox = (): ReactElement => {
    return (
      <td>
        <div>
          <input
            type="checkbox"
            className="multiselect_checkbox"
            checked={this.props.selected}
            disabled={
              !this.props.awardClaim.claim.active || !this.props.levelsValid
            }
            onChange={(): void => {
              return this.props.handleToggleClaim(this.props.awardClaim);
            }}
            value={this.props.awardClaim?.claim.id || ""}
          />
        </div>
      </td>
    );
  };

  renderApproveOrDeny = (): ReactElement => {
    return (
      <td>
        <div
          data-toggle="tooltip"
          title={
            !this.props.awardClaim.claim.active
              ? "This award is deactivated. A global admin must reactivate it to approve."
              : !this.props.levelsValid
              ? "The approval process for this award is currently invalid. A global admin must update it before you can approve or deny this award."
              : null
          }
          className="approve-or-deny"
        >
          <button
            type="button"
            className="btn btn-approve"
            onClick={(): void => {
              return this.handleApproveApprovalRequest();
            }}
            disabled={
              !this.props.awardClaim.claim.active || !this.props.levelsValid
            }
          >
            <i className="fa fa-check" />
          </button>
          <button
            type="button"
            className="btn btn-deny"
            onClick={(): void => {
              return this.handleDenyApprovalRequest();
            }}
            disabled={this.props.isLoading || !this.props.levelsValid}
          >
            <i className="fa fa-times" />
          </button>
        </div>
      </td>
    );
  };

  handleApproveApprovalRequest = (): void => {
    const url = `/awards/approval_request_decisions/approve_multiple`;
    this.props.handleApprovalRequest(this.props.awardClaim, url);
  };

  handleDenyApprovalRequest = (): void => {
    const url = `/awards/approval_request_decisions/deny_multiple`;
    this.props.handleApprovalRequest(this.props.awardClaim, url);
  };

  getClaimClasses = (approvalRequest): string | null => {
    let classes = "";

    if (!approvalRequest.claim.active) {
      classes = "active deactivated";
    }
    if (
      this.props.selectedFilter === "All" ||
      this.props.selectedFilter === approvalRequest.claim.awardId
    ) {
      classes = "active";
    }

    return classes;
  };

  handleFormatUsers = (users): ReactElement[] => {
    const maxLength = 4;
    const truncatedUsers =
      users.length > maxLength ? users.slice(0, maxLength) : users;
    const formattedUsers = truncatedUsers.map(({ name, path, id }, index) => {
      return (
        <a className="profile-url" href={path} key={id}>
          {name}
          {index !== truncatedUsers.length - 1 && ","}
          <br />
        </a>
      );
    });
    if (users.length > maxLength) {
      formattedUsers.push(<b key="and_more">(and more)</b>);
    }
    return formattedUsers;
  };
}
